import * as Yup from 'yup'

export const examesSchema = Yup.object().shape({
  data: Yup.string().nullable().required('Data do exame é obrigatória'),
  nome: Yup.string().required('Nome é obrigatório'),
  descricao: Yup.string().nullable(),
  files: Yup.array().of(
    Yup.mixed()
      .notRequired()
      .test('fileType', 'Somente imagens e pdf são permitidas', (file) => {
        if (!file) return true
        const allowedTypes = [
          // imagens
          'image/jpeg',
          'image/png',
          'image/gif',

          // pdf
          'application/pdf',

          // vídeos
          'video/mp4',
          'video/webm',
          'video/quicktime', // .mov
          'video/x-msvideo', // .avi
        ]

        return allowedTypes.includes(file.type)
      })
  ),
})
